<template>
    <v-container app :fluid="true" class="pt-0">
        <v-row>
            <v-col cols="3">
                <v-autocomplete
                    :items="customers"
                    dense
                    solo
                    clearable 
                    clear-icon="far fa-times-circle"               
                    label="Clientes"
                    persistent-hint
                    :item-text="customText"
                    item-value="id"
                    hide-details
                    @change="handleSelecteCustomer"
                    :filter="customFilter"
                >
                    <template v-slot:item="data">
                        <v-list-item-content>
                            <v-list-item-title v-if="data.item.type_document === 'DNI' ">{{ data.item.name }} {{ data.item.surname }}</v-list-item-title>
                            <v-list-item-title v-else>{{ data.item.name }}</v-list-item-title>
                            <v-list-item-subtitle>{{ data.item.type_document }}: {{ data.item.document }}</v-list-item-subtitle>
                        </v-list-item-content>
                    </template>
                </v-autocomplete>
            </v-col>

            <v-col cols="2">
                <v-menu
                    v-model="menuFromDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                        v-model="from_date"
                        label="Desde"
                        readonly
                        solo
                        dense
                        clearable
                        v-on="on"
                        @click:clear="handleClearFrom"
                        hide-details                                    
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="from_date" 
                        @input="menuFromDate = false" 
                        no-title 
                        locale="es"
                        @change="handleChangeFormDate">
                    </v-date-picker>
                </v-menu>
            </v-col>

            <v-col cols="2">
                <v-menu
                    v-model="menuUntilDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                        v-model="until_date"
                        label="Hasta"
                        dense
                        solo
                        readonly
                        clearable
                        v-on="on"
                        @click:clear="handleClearUntil"
                        hide-details
                        ></v-text-field>
                    </template>
                    <v-date-picker v-model="until_date" 
                        @input="menuUntilDate = false" 
                        no-title 
                        locale="es"
                        @change="handleChangeUntilDate"></v-date-picker>
                </v-menu>
            </v-col>

            <v-col cols="2">
                <v-btn dark color="green" 
                    @click="handleExportExcel"
                    v-if="verifyPermission('exportar_reporte_pedidos')">
                    XLS
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <template>
                        <v-row>
                            <v-col cols="12" class="pt-0">
                                <v-data-table
                                    class="wost-table"
                                    :headers="headers"
                                    :items="orders"
                                    item-key="id"
                                    height="65vh"
                                    show-expand
                                    :single-expand="true"
                                    fixed-header
                                >
                                    <template v-slot:item.id="{item}">
                                        {{ item.id | number-order }}
                                    </template>

                                    <template v-slot:item.customer_id="{item}">
                                        <span v-if="item.customer.type == 'Natural'">
                                            {{ item.customer.name }} {{ item.customer.surname }}
                                        </span>
                                        <span v-else>
                                            {{ item.customer.name }}
                                        </span>
                                        <span :class="'ml-3 order-type-customer order-type-' + item.customer.type_document.toLowerCase() ">
                                            {{ item.customer.type }}
                                        </span>
                                    </template>

                                    <template v-slot:item.entry_time="{item}">
                                        {{ item.entry_time | moment("DD/MM/YYYY") }}
                                    </template>

                                    <template v-slot:item.status="{item}">
                                        <span :class="'order-status order-status-' + item.status.toLowerCase().replace(' ', '-')">
                                            <v-icon size="8" :class="'mr-1 order-status-' + item.status.toLowerCase().replace(' ', '-')">fas fa-circle</v-icon> {{ item.status | uppercase }}
                                        </span>
                                    </template>

                                    <template v-slot:item.delivery_time="{item}">
                                        <span v-if="item.delivery_time">
                                            {{ item.delivery_time | moment("DD/MM/YYYY") }}
                                        </span>                                        
                                    </template>

                                    <template v-slot:item.delivery_hour="{item}">
                                        <span v-if="item.delivery_time">
                                            {{ item.delivery_time | moment("hh:mm a") }}
                                        </span>                                        
                                    </template>

                                    <template v-slot:item.total="{item}">
                                        {{ item.total | currency('S/') }}
                                    </template>

                                    <template v-slot:expanded-item="{ item, headers }">
                                        <td :colspan="headers.length" class="wost-td-expanded">
                                            <orders-detail :order="item" :products="item.detail"></orders-detail>
                                        </td>
                                    </template>

                                </v-data-table>

                            </v-col>
                        </v-row>
                    </template>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import XLSX from 'xlsx'

import { mapActions, mapMutations, mapState } from 'vuex'

import ApiReports from '../../apis/Reports'
import OrdersDetail from '../../components/Reports/OrdersDetails'
import Tools from '../../helpers/Tools'

export default {
    name: 'Orders',
    components: {
        OrdersDetail
    },
    data() {
        return {
            headers: [
                { text: 'Pedido', value: 'id', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Cliente', value: 'customer_id', align: 'left', sortable: false, class: 'header-table' },
                { text: 'Fecha', value: 'entry_time', align: 'left', sortable: false, class: 'header-table' },             
                { text: 'Estado', value: 'status', sortable: false, class: 'header-table' },
                { text: 'F. Entrega', value: 'delivery_time', sortable: false, class: 'header-table' },
                { text: 'H. Entrega', value: 'delivery_hour', sortable: false, class: 'header-table' },
                { text: 'Total', value: 'total', sortable: false, class: 'header-table' },
                { text: '', value: 'data-table-expand', width: 10, class: 'header-table-expand' }
            ],
            orders: [],
            menuFromDate: false,
            from_date: null,
            menuUntilDate: false,
            until_date: null,
            status_filter: true,
            value_status: null,
            customer_id: null,
            value_customer: '',
            final_deliveryman: null
        }
    },
    computed: {
        ...mapState('orders', [
            'status',
            'customers',
            'deliveryUsers'
        ]),
    },
    methods: {
        ...mapActions('orders', [
            'getOrderStatusDropDown',
            'getCustomers',
            'getDeliveryUsers'
        ]),
        ...mapMutations('orders', [
            'setStatus'
        ]),
        handleSelecteBuyer(event) {
            if(event === undefined) {
                this.value_status = null                 
            }
            this.getOrders()
        },
        getOrders(){
            let params = {
                from: this.from_date,
                until: this.until_date,
                status: this.value_status,
                customer_id: this.customer_id,
                final_deliveryman: this.final_deliveryman
            }
            ApiReports.orders(params)
                    .then(({data}) => {
                        this.orders = data
                    })
        },
        handleClearFrom(){
            this.from_date = null
            this.getOrders()
        },
        handleClearUntil(){
            this.until_date = null
            this.getOrders()
        },
        handleChangeFormDate(){
            this.getOrders()
        },
        handleChangeUntilDate(){
            this.getOrders()
        },
        customText(item){
            let text = item.name
            if (item.type_document === 'DNI') {
                text = item.name + ' ' + item.surname
            }
            return text
        },
        customFilter(item, queryText, itemText) {
            let textName = '';
            if (item.name) {
                textName = item.name.toLowerCase();
            }

            let textDocument = '';
            if (item.document) {
                textDocument = item.document.toLowerCase();
            }
            
            let searchText = queryText.toLowerCase()


            return textName.indexOf(searchText) > -1 || textDocument.indexOf(searchText) > -1
        },
        handleSelecteCustomer(value){
            this.customer_id = null            
            if(value !== undefined && value !== null){
                this.customer_id = value
            }
            this.getOrders()
        },
        handleExportExcel(){
            let data = XLSX.utils.json_to_sheet(
                this.prepareDataExport(this.orders),
                {
                    header: [
                        'id',
                        'customer',
                        'type',
                        'entry_time',
                        'delivery_man',
                        'final_deliveryman',
                        'status',
                        'delivery_time',
                        'delivery_hour',
                        'total'
                    ]
                }
            )
            data['A1'].v = 'Pedido'
            data['B1'].v = 'Cliente'
            data['C1'].v = 'Tipo'
            data['D1'].v = 'Fecha'
            data['E1'].v = 'Repartidor Asignado'
            data['F1'].v = 'Repartidor Final'
            data['G1'].v = 'Estado'
            data['H1'].v = 'Fecha de Entrega'
            data['I1'].v = 'Hora de Entrega'
            data['J1'].v = 'Total'
            const workbook = XLSX.utils.book_new()
            const filename = 'reporte-de-pedidos'
            XLSX.utils.book_append_sheet(workbook, data, filename)
            XLSX.writeFile(workbook, `${filename}.xlsx`)
        },
        prepareDataExport(orders){
            let dataExport = []
            orders.forEach(element => {
                
                let name = element.customer.name
                if (element.customer.type == 'Natural') {
                    name = element.customer.name + ' ' + element.customer.surname
                }

                let delivery_man = ''
                if (element.deliverystart) {
                    delivery_man = element.deliverystart.first_name + ' ' + element.deliverystart.last_name
                }

                let final_deliveryman = ''
                if (element.deliveryend) {
                    final_deliveryman = element.deliveryend.first_name + ' ' + element.deliveryend.last_name
                }

                let delivery_time = ''
                let delivery_hour = ''
                if (element.delivery_time) {
                    delivery_time = Tools.setFormatDate(new Date(element.delivery_time))
                    let dateDeliveryTime = new Date(element.delivery_time)
                    delivery_hour = dateDeliveryTime.getHours() + ':' + dateDeliveryTime.getMinutes()
                }
                
                let itemData = {
                    id: element.id,
                    customer: name,
                    type: element.customer.type,
                    entry_time: Tools.setFormatDate(new Date(element.entry_time)),
                    delivery_man: delivery_man,
                    final_deliveryman: final_deliveryman,
                    status: element.status,
                    delivery_time: delivery_time,
                    delivery_hour: delivery_hour,
                    total: element.total
                }
                dataExport.push(itemData)
            })
            return dataExport
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        }
    },
    created () {
        this.getCustomers();
        this.getOrderStatusDropDown();
        this.getOrders();
    }
}
</script>

<style scoped>
.order-type-customer{
    display: inline-block;
    width: 80px;
    text-align: center;
    border-radius: 4px;
    font-size: 12px;
}

.order-type-ruc{
    border: 1px solid #FF6424;
    color: #FF6424;
}

.order-type-dni{
    border: 1px solid #1F308C;
    color: #1F308C;
}
</style>